import { Card, SkeletonCard } from "@endya-conformite/ui-kit";
import { ConformiteDeclarationActiviteIasReadContent } from "@src/conformite/declarationActivite/read/ConformiteDeclarationActiviteIasRead";
import { ControleQuinquennalTemplate } from "@src/controleQuinquennal/ControleQuinquenalTemplate";
import { useControleQuinquennalAdmin } from "@src/controleQuinquennal/admin/useControleQuinquennalAdmin";
import { useDeclarationActiviteAdmin } from "../useDeclarationActiviteAdmin";

export function DeclarationActiviteIasAdminPage() {
  const { entreprise, controleQuinquennal, status, avancement } =
    useControleQuinquennalAdmin();

  const { isLoading, ias } = useDeclarationActiviteAdmin(
    entreprise?.siren,
    controleQuinquennal?.millesime
  );

  if (status !== "loaded" || !entreprise || !controleQuinquennal || isLoading) {
    return (
      <ControleQuinquennalTemplate title="Déclaration d'activité IAS">
        <SkeletonCard />
      </ControleQuinquennalTemplate>
    );
  }

  return (
    <ControleQuinquennalTemplate
      title="Déclaration d'activité IAS"
      backUrl={`/admin/controle-quinquennal/${entreprise.hubspotId}`}
      isValid={avancement[entreprise.siren].declarationActiviteIas === 100}
    >
      <Card>
        <ConformiteDeclarationActiviteIasReadContent
          declarationActivite={ias || null}
        />
      </Card>
    </ControleQuinquennalTemplate>
  );
}
